import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { ServicesProvider } from '@wix/experts-common';
import actions from './filterActions';
import ServicesFilter from './ServicesFilter/ServicesFilter';
import BudgetFilter from './BudgetFilter/BudgetFilter';
import LocationFilter from './LocationFilter/LocationFilter';
import LanguageFilter from './LanguageFilter/LanguageFilter';
import s from './filters.scss';

const mapStateToProps = ({ filters, initialData }) => ({
  filters,
  categories: initialData.categories,
  possibleLanguages: initialData.possibleLanguages,
});

class Filters extends Component {
  render() {
    const {
      t,
      onFilterApply,
      onFilterValueChange,
      onServiceFilterClearClicked,
      filters,
      categories,
      possibleLanguages,
    } = this.props;

    return (
      <div className={s.root} data-hook="filters-section">
        <div className={s.allFiltersWrapper}>
          <div className={s.filterWrapper}>
            <ServicesFilter
              onApply={onFilterApply}
              onChange={onFilterValueChange}
              onClear={onServiceFilterClearClicked}
              currentServices={filters.serviceIds}
              currentCategories={filters.categoryIds}
              categories={categories}
              filterTitle={t('client-exploreexperts-filter-services')}
              applyButtonText={t(
                'client-exploreexperts-services-filter-cta-apply',
              )}
              clearButtonText={t(
                'client-exploreexperts-services-filter-cta-clear',
              )}
            />
          </div>
          <div className={s.filterWrapper}>
            <BudgetFilter
              onApply={onFilterApply}
              onChange={onFilterValueChange}
              currentBudget={{ lower: filters.lower, upper: filters.upper }}
              filterTitle={t('client-exploreexperts-filter-price')}
              applyButtonText={t('client-explore-price-filter-cta-apply')}
              clearButtonText={t('client-explore-price-filter-cta-clear')}
              text={t('client-exploreexperts-filter-price-text')}
              rangeText={t('client-exploreexperts-filter-price-range-text')}
              maxPlusSign={t(
                'client-exploreexperts-filter-price-max-plus-sign',
              )}
            />
          </div>
          <div className={s.filterWrapper}>
            <LocationFilter
              onApply={onFilterApply}
              onChange={onFilterValueChange}
              currentLocation={filters.location}
              filterTitle={t('client-exploreexperts-filter-location')}
              placeholder={t('client-explore-location-filter-placeholder')}
            />
          </div>
          <div className={s.filterWrapper}>
            <LanguageFilter
              currentLanguages={filters.lang}
              onApply={onFilterApply}
              onChange={onFilterValueChange}
              possibleLanguages={possibleLanguages}
              applyButtonText={t('client-explore-language-filter-cta-apply')}
              clearButtonText={t(
                'client-exploreexperts-services-filter-cta-clear',
              )}
              filterTitle={t('client-exploreexperts-filter-language')}
            />
          </div>
        </div>
      </div>
    );
  }
}

Filters.contextTypes = ServicesProvider.childContextTypes;

const ConnectedFilters = connect(mapStateToProps, actions)(Filters);

export default translate()(ConnectedFilters);
